import { DashboardFolderT, DashboardT } from 'business/definitions';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { Box } from '@mui/system';
import { isDashboardType } from './helpers';
import { Typography, useTheme } from '@mui/material';
import FolderSharedIcon from '@mui/icons-material/FolderShared';

export default function DashboardFolderNameCellRenderer({
    value,
}: CellRendererParams<
    DashboardT | DashboardFolderT
>): React.ReactElement | null {
    const theme = useTheme();
    if (!value) return null;
    if (isDashboardType(value)) return <Typography>{value.title}</Typography>;
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                alignItems: 'center',
            }}
        >
            <FolderSharedIcon sx={{ color: theme.palette.success.main }} />
            <Typography>{value.name}</Typography>
        </Box>
    );
}
